export const GET_SUBSCRIBERS = "GET_SUBSCRIBERS";
export const GET_SUBSCRIBERS_SUCCESS = "GET_SUBSCRIBERS_SUCCESS";
export const GET_SUBSCRIBERS_FAILURE = "GET_SUBSCRIBERS_FAILURE";

// ===================================================
// ===================================================

export const DELETE_SUBSCRIBER = "DELETE_SUBSCRIBER";
export const DELETE_SUBSCRIBER_SUCCESS = "DELETE_SUBSCRIBER_SUCCESS";
export const DELETE_SUBSCRIBER_FAILURE = "DELETE_SUBSCRIBER_FAILURE";

// ===================================================
// ===================================================
